import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import {map, timeout} from 'rxjs/operators';
import {UtilsService} from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private http: HttpClient,
    private util: UtilsService
  ) {
  }

  // TODO: PETICIONES SIN HEADER
  // *METODO PARA REALIZAR PETICIONES GET SIN NECESIDAD DE UN TOKEN
  peticionGetSinHeader(innUrl: string) {
    return this.http.get(innUrl)
      .pipe(
        map(res => res[this.util.innEstructuraRespuesta])
      );
  }

  // *METODO PARA REALIZAR PETICIONES POST SIN NECESIDAD DE UN TOKEN
  peticionPostSinHeader(innUrl: string, innObjeto: any) {
    return this.http.post<any>(innUrl, innObjeto)
      .pipe(
        map(res => res[this.util.innEstructuraRespuesta]
        )
      );
  }

  // *METODO PARA REALIZAR PETICIONES PUT SIN NECESIDAD DE UN TOKEN
  peticionPutSinHeader(innUrl: string, innObjeto: any) {
    return this.http.put<any>(innUrl, innObjeto)
      .pipe(
        map(res => res[this.util.innEstructuraRespuesta]
        )
      );
  }

  // *METODO PARA REALIZAR PETICIONES DELETE SIN NECESIDAD DE UN TOKEN
  peticionDeleteSinHeader(innUrl: string, innObjeto?: any) {
    return this.http.delete<any>(innUrl, innObjeto)
      .pipe(
        map(res => res[this.util.innEstructuraRespuesta]
        )
      );
  }

  // TODO: PETICIONES CON HEADER
  // *METODO PARA REALIZAR PETICIONES GET CON LA INYECCION DEL TOKEN
  peticionGetConHeaderSinMapeo(innUrl: string) {
    const headers = this.util.getHeaders();
    return this.http.get<any>(innUrl, {headers});
  }

  // TODO: PETICIONES CON HEADER
  // *METODO PARA REALIZAR PETICIONES GET CON LA INYECCION DEL TOKEN
  peticionGetConHeader(innUrl: string) {
    const headers = this.util.getHeaders();
    return this.http.get(innUrl, {headers})
      .pipe(
        map(res => res[this.util.innEstructuraRespuesta])
      );
  }

  downloadReportePDF(innUrl: string): Observable<Blob> {
    const headers = this.util.getHeaders();
    return this.http.get(innUrl, { headers, responseType: 'blob' });
  }

  downloadReporteBlobPost(innUrl: string, innObjeto: any): Observable<Blob> {
    const headers = this.util.getHeaders();
    return this.http.post(innUrl, innObjeto, { headers, responseType: 'blob' });
  }

  // *METODO PARA REALIZAR PETICIONES POST CON LA INYECCION DEL TOKEN
  peticionPostConHeader(innUrl: string, innObjeto: any, pipe = true) {
    const headers = this.util.getHeaders();
    if(pipe) {
      return this.http.post<any>(innUrl, innObjeto, {headers})
        .pipe(
          map(res => res[this.util.innEstructuraRespuesta]
          )
        );
    }
    return this.http.post<any>(innUrl, innObjeto, {headers});
  }

  // *METODO PARA REALIZAR PETICIONES PUT CON LA INYECCION DEL TOKEN
  peticionPutConHeader(innUrl: string, innObjeto: any) {
    const headers = this.util.getHeaders();
    return this.http.put<any>(innUrl, innObjeto, {headers})
      .pipe(
        map(res => res[this.util.innEstructuraRespuesta]
        )
      );
  }

  // *METODO PARA REALIZAR PETICIONES DELETE CON LA INYECCION DEL TOKEN
  peticionDeleteConHeader(innUrl: string, body?: unknown) {
    const headers = this.util.getHeaders();
    return this.http.delete<any>(innUrl, {headers, body})
      .pipe(
        map(res => res[this.util.innEstructuraRespuesta]
        )
      );
  }

  // TODO: PETICIONES CON TIME OUT
  // *METODO PARA REALIZAR PETICIONES GET CON TIMEOUT
  peticionGetConHeaderTimeOut(innUrl: string, timeOut: number) {
    const headers = this.util.getHeaders();
    return this.http.get(innUrl, {headers})
      .pipe(
        timeout(timeOut),
        map(res => res[this.util.innEstructuraRespuesta])
      );
  }

  // *METODO PARA REALIZAR PETICIONES POST CON TIMEOUT
  peticionPostConHeaderTimeOut(innUrl: string, innObjeto: any, timeOut: number) {
    const headers = this.util.getHeaders();
    return this.http.post<any>(innUrl, innObjeto, {headers})
      .pipe(
        timeout(timeOut),
        map(res => res[this.util.innEstructuraRespuesta]
        )
      );
  }

  // PETICION C/HEADER APIS PERSONALIZADAS
  peticionGetConHeaderApiKey(innUrl: string, apikey:string) {
    const headers = this.util.getHeadersApiKeyCustom(apikey);
    return this.http.get<any>(innUrl, {headers});
  }

}
